// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content-label[data-v-20e0e778] {\r\n  font-size: inherit;\r\n  display: block;\r\n  width: 100%;\n}\n[dir] .content-label[data-v-20e0e778] {\r\n  cursor: pointer;\n}\r\n", ""]);
// Exports
module.exports = exports;
